<template>
  <DefaultLayout
    menuIndex="/workshop"
    openeds="attribution"
  >

    <div class="page-header">
      <div>
        <el-select
          style="margin-right: 5px;"
          v-model="preselect.companyName"
          clearable
          placeholder="请选择公司"
          @change="preselectCompanyChange"
          @clear="this.preselectFactory = []; preselect.factoryName = ''; this.preselectCompanyId = ''; this.tableData = [];"
        >
          <el-option
            v-for="item in universalCompany"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-model="preselect.factoryName"
          clearable
          placeholder="请选择厂区"
          @change="preselectFactoryChange"
          @clear="this.tableData = [];"
        >
          <el-option
            v-for="item in preselectFactory"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div>
        <el-button
          type="primary"
          @click="dialogFormVisible = true"
        >
          <el-icon>
            <Plus />
          </el-icon>
        </el-button>
      </div>
    </div>

    <el-dialog
      v-model="dialogFormVisible"
      title="新增车间"
      width="500px"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-form-item
          label="车间名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            v-model="form.name"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="所属公司"
          :label-width="formLabelWidth"
          prop="company"
        >
          <el-select
            v-model="form.company"
            clearable
            placeholder="请选择公司"
            @change="optionsCompanyChange"
            @clear="this.optionsFactory = []; form.factory = '';"
          >
            <el-option
              v-for="item in universalCompany"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属厂区"
          :label-width="formLabelWidth"
          prop="factory"
        >
          <el-select
            v-model="form.factory"
            clearable
            placeholder="请选择厂区"
          >
            <el-option
              v-for="item in optionsFactory"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="formCancel('form')">重置</el-button>
          <el-button
            type="primary"
            @click="formSubmit('form')"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>

    <div style="padding:20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column
          label="#"
          type="index"
          width="50"
          :resizable="false"
        />
        <el-table-column
          prop="name"
          label="车间名称"
          width="200"
          :resizable="false"
        />
        <el-table-column
          prop="factory"
          label="所属厂区"
          width="200"
          :resizable="false"
        />
        <el-table-column
          prop="company"
          label="所属公司"
          :resizable="false"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="120"
          :resizable="false"
        >
          <template #default="scope">
            <el-button
              @click="openDelete(scope)"
              type="danger"
            >
              <el-icon>
                <Delete />
              </el-icon>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../components/layout/DefaultLayout.vue'
import { Companies, Factories, Workshops } from '../api/request.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue';
import { markRaw } from 'vue';

export default {
  name: 'WorkshopPage',
  components: {
    DefaultLayout
  },
  methods: {
    getCompanyAccountInformation () {
      Companies.GetCompanyAccountInformation().then(res => {
        // console.log(res);
        let optionsCompanyTem = [];
        let companyKeyValueTem = {};
        for (let i = 0, len = res.length; i < len; i++) {
          optionsCompanyTem.push({
            value: res[i].id,
            label: res[i].name
          });
          companyKeyValueTem[res[i].id] = res[i].name;
        }
        this.universalCompany = optionsCompanyTem;
        this.companyKeyValue = companyKeyValueTem;
      })
    },
    getFactories (companyId, type) {
      Factories.GetFactories(companyId).then(res => {
        // console.log(res);
        let optionsFactoryTem = [];
        let factoryKeyValueTem = {};
        for (let i = 0, len = res.length; i < len; i++) {
          optionsFactoryTem.push({
            value: res[i].id,
            label: res[i].name
          });
          factoryKeyValueTem[res[i].id] = res[i].name;
        }
        if (type === '1') {
          this.optionsFactory = optionsFactoryTem;
        } else {
          this.preselectFactory = optionsFactoryTem;
          this.factoryKeyValue = factoryKeyValueTem;
        }
      })
    },
    getWorkshops (factoryId) {
      Workshops.GetWorkshops(factoryId).then(res => {
        // console.log(res);
        let tableDataTem = [];
        for (let i = 0, len = res.length; i < len; i++) {
          tableDataTem.push({
            name: res[i].name,
            company: this.companyKeyValue[this.preselectCompanyId],
            factory: this.factoryKeyValue[factoryId],
            workshopsId: res[i].id,
            factoryId: res[i].factoryId
          });
        }
        this.tableData = tableDataTem;
      })
    },
    formCancel (formName) {
      this.$refs[formName].resetFields();
      this.optionsFactory = [];
    },
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Workshops.AddWorkshops(
            this.form.name,
            this.form.factory,
          ).then(() => {
            // console.log(res);
            ElMessage({
              showClose: true,
              message: '添加车间成功',
              type: 'success',
            })
            if (this.preselect.factoryName === this.form.factory) {
              this.preselectFactoryChange(this.preselect.factoryName);
            }
            this.dialogFormVisible = false;
            this.$refs[formName].resetFields();
          })
        }
      })
    },
    openDelete (data) {
      // console.log(data.row);
      ElMessageBox.confirm(
        `<strong style="color: #F56C6C;">确定删除 ${data.row.name} 的信息?</strong>`,
        {
          type: 'error',
          showCancelButton: false,
          autofocus: false,
          confirmButtonClass: 'workshopPage-delete-confirmButtonClass',
          dangerouslyUseHTMLString: true,
          icon: markRaw(WarningFilled),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }
      ).then(() => {
        Workshops.DeleteWorkshops(data.row.workshopsId).then((res) => {
          if (res === 'success') {
            ElMessage({
              showClose: true,
              type: 'success',
              message: '删除成功',
            })
            this.getWorkshops(data.row.factoryId);
          } else {
            ElMessage({
              showClose: true,
              type: 'error',
              message: '网络错误',
            })
          }
        })
      })
        .catch(() => {
          ElMessage({
            showClose: true,
            type: 'info',
            message: '取消删除',
          })
        })
    },
    //table改变
    preselectCompanyChange (val) {
      // console.log(val);
      if (val !== '') {
        this.getFactories(val, '2');
        this.preselectCompanyId = val;
        this.preselect.factoryName = '';
        this.tableData = [];
      }
    },
    preselectFactoryChange (val) {
      if (val !== '') {
        this.getWorkshops(val);
      }
    },
    //form改变
    optionsCompanyChange (val) {
      if (val !== '') {
        this.getFactories(val, '1');
      }
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      formLabelWidth: '80px',
      form: {
        name: '',
        company: '',
        factory: '',
      },
      tableData: [
        // {
        //     name: '车间名称',
        //     company: '公司名称',
        //     factory: '厂区名称',
        //     workshopsId: '1',
        //     factoryId: '1'
        // },
      ],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        company: [
          { required: true, message: '请选择公司', trigger: 'blur' },
        ],
        factory: [
          { required: true, message: '请选择厂区', trigger: 'blur' },
        ],
      },
      universalCompany: [
        // {
        //     value: 'companyId',
        //     label: '公司名称',
        // },
      ],
      //form展示
      optionsFactory: [
        // {
        //     value: 'factoryId',
        //     label: '厂区名称',
        // },
      ],
      //table展示
      preselectFactory: [

      ],
      preselect: {
        companyName: '',
        factoryName: '',
      },
      companyKeyValue: {},
      factoryKeyValue: {},
      preselectCompanyId: '',
    }
  },
  created () {
    this.getCompanyAccountInformation();
  }
}
</script>

<style>
.workshopPage-delete-confirmButtonClass {
  background: #F56C6C !important;
  border: 0;
}
</style>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input,
.el-date-editor.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
